(() => {
  const boot = () => document.querySelectorAll('[data-mobile-pc-filter-dialog]').forEach(setup);
  function setup(dialog) {
    // Redesigned collection pages use their real controls at both breakpoints.
    // Moving the panel keeps its catalogue, listeners and selected values intact.
    if (dialog.closest('[data-elite-sidebar-redesign]')) {
      window.ElitePCSidebar?.setupDrawer(dialog);
      return;
    }
    const root = dialog.closest('[data-elite-collection-grid][data-collection-handle="gaming-pcs"]');
    if (!root || dialog.dataset.mobilePcFilterReady) return;
    dialog.dataset.mobilePcFilterReady = 'true';
    const trigger = root.querySelector('[data-mobile-pc-filter-open]');
    const controls = root.querySelector('.elite-listing__browse-controls');
    if (!trigger || !controls || typeof dialog.showModal !== 'function') return;
    controls.after(trigger);
    document.body.append(dialog);
    trigger.dataset.mobilePcFilterReady = 'true';
    const groups = dialog.querySelector('[data-mobile-pc-filter-groups]');
    const show = dialog.querySelector('[data-mobile-pc-filter-show]');
    const mobile = window.matchMedia('(max-width: 749px)');
    const filterRoot = () => root.querySelector('[data-elite-collection-configurator]');
    const sourceSelect = id => Array.from(root.querySelectorAll('[data-elite-configurator-filter-select]')).find(s => s.dataset.filterId === id);
    const budgets = () => Array.from(root.querySelectorAll('[data-collection-filter="budget"]'));
    const stockMode = () => filterRoot()?.dataset.eliteStockMode || 'in_stock';
    let payload = null;
    let signature = '';
    let frame = 0;
    const expanded = new Map();
    function catalogue() {
      if (!payload) {
        try { payload = JSON.parse(root.querySelector('[data-elite-collection-configurator-payload]')?.textContent || 'null'); } catch { /* Wait for catalogue hydration. */ }
      }
      return payload || { cases: [], filters: [] };
    }
    function element(tag, className, text) {
      const node = document.createElement(tag);
      if (className) node.className = className;
      if (text !== undefined) node.textContent = text;
      return node;
    }
    function group(id, title, count, open) {
      const details = element('details', 'epc-mobile-filters__group');
      details.dataset.mobileGroup = id;
      details.open = expanded.has(id) ? expanded.get(id) : open;
      const summary = element('summary');
      summary.append(element('span', '', title));
      summary.append(element('span', 'epc-mobile-filters__count', count == null ? '' : `(${count})`));
      const content = element('div', 'epc-mobile-filters__group-content');
      details.append(summary, content);
      details.addEventListener('toggle', () => expanded.set(id, details.open));
      return { details, content };
    }
    function tile(text, key, active, action) {
      const button = element('button', 'epc-mobile-filters__tile');
      button.type = 'button';
      button.dataset.mobileKey = key;
      button.setAttribute('aria-pressed', String(active));
      button.setAttribute('aria-label', text);
      button.addEventListener('click', action);
      button.append(element('span', '', text));
      return button;
    }
    function changeSelect(id, value) {
      const select = sourceSelect(id);
      if (!select) return;
      select.value = value;
      select.dispatchEvent(new Event('change', { bubbles: true }));
      queue();
    }
    function budgetGroup() {
      const result = group('budget', 'Budget', null, true);
      const grid = element('div', 'epc-mobile-filters__tiles epc-mobile-filters__tiles--budget');
      const ranges = [['Under £1,000', ['under-800', '800-1000']], ['£1,000 – £1,500', ['1000-1500']], ['£1,500 – £2,000', ['1500-2000']], ['£2,000+', ['2000-plus']]];
      ranges.forEach(([label, values]) => {
        const inputs = budgets().filter(input => values.includes(input.value));
        const active = inputs.some(input => input.checked);
        const button = tile(label, `budget-${values[0]}`, active, () => {
          inputs.forEach(input => { input.checked = !active; });
          // One event applies the combined Under £1,000 range without a second request.
          inputs[0]?.dispatchEvent(new Event('change', { bubbles: true }));
          queue();
        });
        button.disabled = inputs.length === 0;
        grid.append(button);
      });
      result.content.append(grid);
      return result.details;
    }
    const normal = value => String(value || '').toLowerCase().replace(/[^a-z0-9]/g, '');
    function caseImage(type, field = 'type') {
      const candidates = catalogue().cases.filter(item => normal(item[field]) === normal(type));
      const preferred = { noglasscase: /Fractal Design Pop Mini Silent/i, sideglasscase: /Fractal Design Epoch Black TG RGB/i, frontsideglasscase: /ASUS A31 Plus.*BLACK/i, frontandsideglasscase: /ASUS A31 Plus.*BLACK/i, panoramicglasscase: /Lian Li O11/i, woodfrontairflowcase: /Fractal Design North/i }[normal(type)];
      const selected = candidates.find(item => preferred?.test(item.title) && item.image)
        || candidates.find(item => item.availability?.available && normal(item.colour) === 'black' && item.image)
        || candidates.find(item => item.availability?.available && item.image) || candidates.find(item => item.image);
      return selected?.image || '';
    }
    function swatch(label) {
      const colours = { black: '#24272b', white: '#eef1f7', brown: '#79553d', beige: '#dfcfb5', magenta: '#d91ebd', orange: '#ff7a1a', blue: '#1f5eff', grey: '#8b949e', charcoal: '#79553d' };
      const values = label.toLowerCase().split(/\s*&\s*|\s+and\s+/).map(value => colours[value.trim()] || '#8b949e');
      return values;
    }
    function caseGroup(id, title, colour) {
      const select = sourceSelect(id);
      const options = Array.from(select?.options || []).filter(option => option.value);
      if (colour) {
        const order = ['black', 'white', 'blackbrown', 'beige'];
        options.sort((a, b) => {
          const rank = option => { const index = order.indexOf(normal(option.textContent)); return index < 0 ? order.length : index; };
          return rank(a) - rank(b);
        });
      }
      const result = group(id, title, null, true);
      const grid = element('div', `epc-mobile-filters__tiles epc-mobile-filters__tiles--${colour ? 'colour' : 'case'}`);
      options.forEach(option => {
        const text = option.textContent.trim().replace(/ Case$/, '').replace('Wood Front Airflow', 'Wood Front');
        const button = tile(text, `${id}-${option.value}`, select.value === option.value, () => changeSelect(id, select.value === option.value ? '' : option.value));
        if (colour) {
          const visual = element('span', 'epc-mobile-filters__swatch');
          visual.setAttribute('aria-hidden', 'true');
          swatch(option.textContent).forEach(colour => {
            const half = element('span', 'epc-mobile-filters__swatch-colour');
            half.style.backgroundColor = colour;
            visual.append(half);
          });
          button.prepend(visual);
        } else {
          const image = element('img');
          image.src = caseImage(option.textContent, id === 'case_style' ? 'style' : 'type') || option.dataset.eliteComponentImage || '';
          image.alt = '';
          image.width = 96;
          image.height = 96;
          image.decoding = 'async';
          image.style.filter = `url(#${dialog.querySelector('filter').id})`;
          button.prepend(image);
        }
        grid.append(button);
      });
      if (!options.length) grid.append(element('span', '', 'Loading case options…'));
      result.content.append(grid);
      return result.details;
    }
    function componentGroup(id, title, ids) {
      const selects = ids.map(sourceSelect).filter(Boolean);
      const count = selects.reduce((total, select) => total + Array.from(select.options).filter(option => option.value).length, 0);
      const result = group(id, title, count, false);
      selects.forEach(source => {
        const label = element('label', 'epc-mobile-filters__field');
        if (ids.length > 1) label.append(element('span', '', source.closest('[data-elite-configurator-filter]')?.querySelector('span')?.textContent || source.dataset.filterId));
        const select = source.cloneNode(true);
        // These are UI proxies; keep the existing configurator as the single source of truth.
        Array.from(select.attributes).forEach(attr => { if (attr.name.startsWith('data-') || attr.name === 'id' || attr.name === 'name') select.removeAttribute(attr.name); });
        select.value = source.value;
        select.dataset.mobileKey = `select-${source.dataset.filterId}`;
        select.setAttribute('aria-label', ids.length > 1 ? label.textContent : title);
        select.addEventListener('change', () => changeSelect(source.dataset.filterId, select.value));
        label.append(select);
        result.content.append(label);
      });
      return result.details;
    }

    function render() {
      const sources = Array.from(root.querySelectorAll('[data-elite-configurator-filter-select]'));
      const next = JSON.stringify([sources.map(s => [s.dataset.filterId, s.value, Array.from(s.options).map(o => [o.value, o.textContent])]), budgets().filter(i => i.checked).map(i => i.value), stockMode(), mobile.matches]);
      if (next !== signature) {
        signature = next;
        const key = groups.contains(document.activeElement) ? document.activeElement.dataset.mobileKey : null;
        groups.querySelectorAll('details').forEach(d => expanded.set(d.dataset.mobileGroup, d.open));
        groups.replaceChildren(budgetGroup(), caseGroup('case_colour', 'Case Colour', true), caseGroup('case_style', 'Case Style', false), caseGroup('case', 'Case Type', false), componentGroup('cpu', 'Processor', ['cpu']), componentGroup('gpu', 'Graphics Card', ['gpu']), componentGroup('ram', 'Memory', ['ram']), componentGroup('storage', 'Storage', ['nvme_ssd', 'sata_ssd', 'sata_hdd']), componentGroup('psu', 'Power Supply', ['psu']),
          ...(!mobile.matches ? sources.filter(source => !['case', 'case_colour', 'case_style', 'cpu', 'gpu', 'ram', 'nvme_ssd', 'sata_ssd', 'sata_hdd', 'psu'].includes(source.dataset.filterId)).map(source =>
            componentGroup(source.dataset.filterId, source.closest('[data-elite-configurator-filter]')?.querySelector('span')?.textContent || source.dataset.filterId, [source.dataset.filterId])) : []));
        if (key) Array.from(groups.querySelectorAll('[data-mobile-key]')).find(e => e.dataset.mobileKey === key)?.focus({ preventScroll: true });
      }
      const active = sources.filter(s => s.value).length + (budgets().some(i => i.checked) ? 1 : 0) + (stockMode() !== 'in_stock' ? 1 : 0);
      const badge = trigger.querySelector('[data-mobile-pc-filter-selected]');
      badge.hidden = !active;
      badge.textContent = active ? String(active) : '';
      const status = root.querySelector('[data-collection-status]')?.textContent || '';
      const total = status.match(/Showing\s+(\d+)\s+of\s+(\d+)/i) || status.match(/Showing\s+(\d+)/i);
      const count = total ? Number(total[2] || total[1]) : null;
      const busy = root.classList.contains('is-loading') || /finding compatible|calculating|loading/i.test(status);
      show.disabled = busy;
      show.textContent = busy ? 'Updating PCs…' : count == null ? 'Show PCs' : `Show ${count} PC${count === 1 ? '' : 's'}`;
    }
    function queue() {
      if (frame) return;
      frame = requestAnimationFrame(() => { frame = 0; render(); });
    }
    function close() { if (mobile.matches && dialog.open) dialog.close(); }
    // The same filter UI is an inline sidebar on desktop and a modal on mobile.
    // Hidden catalogue controls remain the single source of truth at both sizes.
    function syncLayout() {
      if (dialog.open) dialog.close();
      dialog.classList.toggle('epc-desktop-filters', !mobile.matches);
      if (mobile.matches) {
        document.body.append(dialog);
        dialog.removeAttribute('role');
        delete root.dataset.desktopPcFilterReady;
      } else if (root.hasAttribute('data-standard-pc-collection')) {
        document.body.append(dialog);
        dialog.classList.remove('epc-desktop-filters');
        dialog.removeAttribute('role');
        delete root.dataset.desktopPcFilterReady;
      } else if (host?.isConnected) {
        host.before(dialog);
        dialog.setAttribute('role', 'complementary');
        dialog.setAttribute('open', '');
        root.dataset.desktopPcFilterReady = 'true';
      }
      render();
    }
    trigger.addEventListener('click', () => {
      if (!mobile.matches) return;
      render();
      dialog.showModal();
      trigger.setAttribute('aria-expanded', 'true');
      document.documentElement.classList.add('epc-mobile-filters-open');
      dialog.querySelector('[data-mobile-pc-filter-close]').focus({ preventScroll: true });
    });
    dialog.querySelector('[data-mobile-pc-filter-close]').addEventListener('click', close);
    show.addEventListener('click', close);
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) close();
    });
    dialog.addEventListener('close', () => {
      document.documentElement.classList.remove('epc-mobile-filters-open');
      const wasModal = trigger.getAttribute('aria-expanded') === 'true';
      trigger.setAttribute('aria-expanded', 'false');
      if (mobile.matches && wasModal) trigger.focus({ preventScroll: true });
    });
    dialog.querySelectorAll('[data-mobile-pc-filter-reset]').forEach(button => button.addEventListener('click', () => {
      root.querySelector('[data-budget-clear]')?.click();
      root.querySelector('[data-elite-filter-clear]')?.click();
      queue();
    }));
    mobile.addEventListener('change', syncLayout);
    const observer = new MutationObserver(queue);
    const host = root.querySelector('[data-elite-collection-generated-filter-host]');
    if (host) observer.observe(host, { subtree: true, childList: true, attributes: true, attributeFilter: ['aria-pressed', 'aria-checked'], characterData: true });
    const status = root.querySelector('[data-collection-status]');
    if (status) observer.observe(status, { childList: true, characterData: true, subtree: true });
    observer.observe(root, { attributes: true, attributeFilter: ['class'] });
    ['elite:collection-configurator:change', 'elite:collection-configurator:option-scope', 'elite:budget-builds:updated'].forEach(name => document.addEventListener(name, queue));
    root.addEventListener('change', queue);
    window.addEventListener('popstate', queue);
    syncLayout();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
})();
